import { useContext } from 'react';
import { ThemeContext, IThemeContext } from './theme-context';

/**
 * Hook to access and modify the current theme
 * @returns Object containing the current theme and a function to update it
 * @throws Error if used outside of ThemeProvider
 */
const useTheme = (): IThemeContext => {
  const context = useContext(ThemeContext);

  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }

  return context;
};

export default useTheme;
